// ./src/components/generic/form/TextAreaField.tsx
//
// Textarea wrapper on the shared `(name, value)` change contract.

import React from 'react';
import { Textarea, TextareaProps } from '@mantine/core';

import { FieldChangeHandler } from './types';

export interface TextAreaFieldProps extends Omit<TextareaProps, 'onChange' | 'value'> {
  name?: string;
  value?: string | null;
  onChange?: FieldChangeHandler<string>;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({ name, value, onChange, ...rest }) => (
  <Textarea
    name={name}
    value={value ?? ''}
    onChange={(e) => onChange?.(name, e.currentTarget.value)}
    {...rest}
  />
);
